var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.taskDetail
        ? _c(
            "el-descriptions",
            { attrs: { title: "任务详情", column: 2, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "任务编号" } }, [
                _vm._v(_vm._s(_vm.taskDetail.code)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                _vm._v(_vm._s(_vm.taskDetail.createdAt)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "已完成设备数" } }, [
                _vm._v(_vm._s(_vm.taskDetail.finishedEquipmentCount)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "任务ID" } }, [
                _vm._v(_vm._s(_vm.taskDetail.id)),
              ]),
              _vm._v(" "),
              _c("el-descriptions-item", { attrs: { label: "外部ID" } }, [
                _vm._v(_vm._s(_vm.taskDetail.outerId)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.taskDetail && _vm.taskDetail.regions
        ? _vm._l(_vm.taskDetail.regions, function (region, regionIndex) {
            return _c(
              "div",
              { key: regionIndex, staticStyle: { "margin-top": "20px" } },
              [
                _c("h3", [_vm._v("区域 " + _vm._s(regionIndex + 1))]),
                _vm._v(" "),
                _vm._l(region.equipments, function (equipment, equipmentIndex) {
                  return _c(
                    "div",
                    {
                      key: equipmentIndex,
                      staticStyle: { "margin-left": "20px" },
                    },
                    [
                      _c("h4", [
                        _vm._v(
                          "设备: " +
                            _vm._s(equipment.equipmentName) +
                            " (" +
                            _vm._s(equipment.equipmentCode) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        equipment.positions,
                        function (position, positionIndex) {
                          return _c(
                            "div",
                            {
                              key: positionIndex,
                              staticStyle: { "margin-left": "20px" },
                            },
                            [
                              _c("h5", [
                                _vm._v("位置: " + _vm._s(position.position)),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "提示信息: " + _vm._s(position.promptMessage)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: position.checkItems,
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "content",
                                      label: "检查项内容",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "type", label: "类型" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "测量结果" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.batchMeasureResult &&
                                              scope.row.batchMeasureResult
                                                .length > 0
                                                ? _c(
                                                    "div",
                                                    _vm._l(
                                                      scope.row
                                                        .batchMeasureResult,
                                                      function (
                                                        measure,
                                                        measureIndex
                                                      ) {
                                                        return _c(
                                                          "p",
                                                          { key: measureIndex },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  measure.name
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  measure.value
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.measureResult
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "result", label: "结果" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.result)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "result", label: "图片" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.uploadPhotos.length > 0
                                                ? _vm._l(
                                                    scope.row.uploadPhotos,
                                                    function (
                                                      image,
                                                      imageIndex
                                                    ) {
                                                      return _c("el-image", {
                                                        key: imageIndex,
                                                        staticClass: "image",
                                                        attrs: {
                                                          "preview-src-list": [
                                                            scope.row
                                                              .uploadPhotos,
                                                          ],
                                                          src: image,
                                                          fit: "contain",
                                                        },
                                                      })
                                                    }
                                                  )
                                                : _c("span"),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "description",
                                      label: "描述",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.description)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                }),
              ],
              2
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }